<template>
    <b-badge v-if="($safe(row,'Errors') || []).length == 0" variant="success">Oluşturulmaya Hazır</b-badge>
    <b-badge v-else variant="danger">{{($safe(row,'Errors') || []).length}} adet bilgiye ihtiyacı var.</b-badge>
</template>

<script>
import {BBadge} from 'bootstrap-vue'
import moment from 'moment'
export default {
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:[Object,String,Array,Number]
    },
    methods:{
        getDate(date){
            return moment(date).locale('tr').format('DD.MM.YYYY')
        }
    }
}
</script>

<style>

</style>